import React from "react";
import { StaticRouterLinks } from "../utils/StaticRouterLinks";
import SignInLayout from "../pages/Layout/SignInLayout";
import { Route, Routes } from "react-router-dom";
import DocumentationLayout from "../pages/Layout/DocumentationLayout";
import AccountClosing from "../pages/AccountClosing";
import Login from "../pages/Login";
import LoginOTP from "../pages/LoginOTP";

export default function Routing() {
  return (
    <Routes>
      <Route element={<SignInLayout />}>
        <Route exact path={StaticRouterLinks?.home} element={<Login />} />
        <Route
          exact
          path={StaticRouterLinks?.loginOTP}
          element={<LoginOTP />}
        />
      </Route>
      <Route element={<DocumentationLayout />}>
        <Route
          exact
          path={StaticRouterLinks.document}
          element={<AccountClosing />}
        />
      </Route>
    </Routes>
  );
}
